<template>
    <div
        class="vx-flex vx-flex-row vx-items-start vx-justify-start vx-gap-3 vx-rounded-md vx-bg-sky-100 vx-p-4 vx-text-sm vx-text-sky-800"
    >
        <font-awesome-icon :icon="props.icon" class="vx-mt-1 vx-text-sky-500" />

        <div class="vx-w-full vx-space-y-2">
            <slot></slot>

            <div
                v-if="props.activeBlock !== -1"
                class="vx-flex vx-w-full vx-flex-row vx-gap-1 vx-overflow-hidden vx-rounded-full"
            >
                <div
                    v-for="n in props.blocks"
                    :key="n"
                    class="vx-h-1 vx-w-full"
                    :class="{
            'vx-bg-sky-200': n > props.activeBlock,
            'vx-bg-sky-500': n <= props.activeBlock,
            'vx-animate-[pulse_1s_cubic-bezier(0.4,_0,_0.6,_1)_infinite]':
              n === props.activeBlock,
          }"
                ></div>
            </div>

            <div
                v-if="props.activeBlock === -1"
                class="vx-flex vx-w-full vx-flex-row vx-gap-1 vx-overflow-hidden vx-rounded-full"
            >
                <div class="vx-h-1 vx-w-full vx-bg-sky-200"></div>
            </div>

            <figure>
                <figcaption class="vx-text-sky-500">
                    <slot name="caption"></slot>
                </figcaption>
            </figure>
        </div>
    </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps({
    blocks: {
        type: Number,
        required: false,
    },
    activeBlock: {
        type: Number,
        required: false,
    },
    icon: {
        type: Object,
        required: true,
    },
})
</script>
